// The build-time map of resolved @ergeon versions. Producer and consumers all come through
// here, so the build and its readers cannot drift on a package name or on the placeholder.
//
// Separate from packageVersions.ts, which reaches libVersionManager and the getVersion()
// chain of every @ergeon package. Not for the bundle — that chain is in the entry graph via
// sentry.ts either way — but for jest, where it costs ~90 s and over a gigabyte per worker.

export const CAD_3D_DATA_PACKAGE = 'cad-3d-data';

export const ERGEON_VERSIONED_PACKAGES = [
  '3d-lib',
  'cad',
  CAD_3D_DATA_PACKAGE,
  'core-components',
  'draft-editor',
  'erg-auth',
  'erg-catalog-rules',
  'erg-utils-js',
  'pricing-lib',
];

// What the build records for a package whose manifest could not be read. It is not a
// version: anything keyed on it would never move again.
export const UNRESOLVED_VERSION = 'unknown';

// JSON.parse answers null, arrays and bare strings without throwing, and callers index
// the result, so what comes back has to be an object before it is handed on.
const isVersionMap = (value: unknown): value is Record<string, string> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const parsePackageVersionTags = (raw?: string): Record<string, string> => {
  try {
    const parsed: unknown = JSON.parse(raw ?? '{}');
    return isVersionMap(parsed) ? parsed : {};
  } catch {
    return {};
  }
};
